export class SimpleLanguage {
    symbol: string = "";
    id: string = "";
    name: string = "";
}

export const LANGUAGES_de: SimpleLanguage[] = [
    {
        id: "en",
        name: "Englisch",
        symbol: "assets/images/flags/us.gif"
    } as SimpleLanguage,
    {
        id: "de",
        name: "Deutsche",
        symbol: "assets/images/flags/de.gif"
    } as SimpleLanguage
]

export const LANGUAGES_en: SimpleLanguage[] = [
    {
        id: "en",
        name: "English",
        symbol: "assets/images/flags/us.gif"
    } as SimpleLanguage,
    {
        id: "de",
        name: "German",
        symbol: "assets/images/flags/de.gif"
    } as SimpleLanguage
]